import {Component, Input} from '@angular/core';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {SplittedCostTableElementV1, SplittedCostTableElementV2} from '../../../../interfaces';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';


@Component({
  selector: 'app-splitted-costs-table-v2',
  templateUrl: './splitted-costs-table-component-v2.component.html',
  styleUrls: ['./splitted-costs-table-component-v2.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule
  ]
})
export class SplittedCostsTableV2Component {

  public budgetDataSource: MatTableDataSource<SplittedCostTableElementV2> = new MatTableDataSource([]);
  public displayColumns = [];

  @Input()
  private isExport = false;

  get isExportBudget() {
    return this.isExport;
  }

  @Input()
  set isExportBudget(isExport: boolean) {
    this.isExport = isExport;
    if (isExport) {
      this.displayColumns = ['name', 'cost', 'profit', 'commission', 'expenses', 'total', 'totalEuro', 'taxes'];
    } else {
      this.displayColumns = ['name', 'cost', 'profit', 'commission', 'expenses', 'total'];
    }
  }

  @Input()
  set summary(newTableData: SplittedCostTableElementV1[] | SplittedCostTableElementV2[]) {
    if (!newTableData) {
      return;
    }
    console.log('SplittedCostsTableComponentV2: received new splitted cost table to show: ', newTableData);
    this.budgetDataSource.data = newTableData as SplittedCostTableElementV2[];
  }
}
